import styled from 'styled-components'

export const Form = styled.form`
  width: 910px;
  margin-top: 96px;
`

export const LogoContainer = styled.div`
  display: flex;
  justify-content: space-between;

  & > * {
    display: flex;
  }

  label {
    cursor: pointer;
    display: flex;
    padding: 10px 0;
    align-items: center;
  }

  input {
    cursor: pointer;
    margin-right: 20px;

    &:disabled ~ * {
      opacity: 0.5;
    }
  }
`
